/**
 * L2-P3: moved to @miq/platform-ui (components/location-permissions/location-permissions.component.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform-ui'.
 */
export { LocationPermissionsComponent } from '@miq/platform-ui';
